import type { ClientSearchSortOrder, SearchSortOrder, ServiceSearchSortOrder, } from "../store/schema/SearchTableQuery";

/**
 * Whether the sort order must be applied on the client after every result has been fetched.
 */
export function isClientSearchSortOrder(sortOrder: SearchSortOrder | undefined): sortOrder is ClientSearchSortOrder {
    return (isSenderSearchSortOrder(sortOrder) ||
        isRecipientSearchSortOrder(sortOrder) ||
        sortOrder === "DateTimeAscending" ||
        isCategorySearchSortOrder(sortOrder));
}

/**
 * Whether the sort order sorts by sender, in either direction.
 */
export function isSenderSearchSortOrder(sortOrder: SearchSortOrder | undefined): sortOrder is "Sender" | "SenderDescending" {
    return sortOrder === "Sender" || sortOrder === "SenderDescending";
}

export function isDateSearchSortOrder(sortOrder: SearchSortOrder | undefined): sortOrder is "DateTime" | "DateTimeAscending" {
    return sortOrder === "DateTime" || sortOrder === "DateTimeAscending";
}

export function isCategorySearchSortOrder(sortOrder: SearchSortOrder | undefined): sortOrder is "Category" | "CategoryDescending" {
    return sortOrder === "Category" || sortOrder === "CategoryDescending";
}

/**
 * Whether the sort order sorts by recipient, in either direction.
 */
export function isRecipientSearchSortOrder(sortOrder: SearchSortOrder | undefined): sortOrder is "Recipient" | "RecipientDescending" {
    return sortOrder === "Recipient" || sortOrder === "RecipientDescending";
}

/**
 * Maps a search sort order onto the order the search service should fetch results in. Client-side
 * sort orders fetch newest first so the fetched set is stable and the date tiebreak is cheap.
 */
export function getServiceSearchSortOrder(sortOrder: SearchSortOrder | undefined): ServiceSearchSortOrder | undefined {
    return isClientSearchSortOrder(sortOrder) ? "DateTime" : sortOrder;
}
